/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const Delivery: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M0.553005 4.10579C1.04698 3.8588 1.64766 4.05903 1.89465 4.55301L3.61825 8.00022H9.38218L11.1058 4.55301C11.2752 4.21422 11.6214 4.00022 12.0002 4.00022H23.0002C23.3468 4.00022 23.6687 4.17967 23.8509 4.47449C24.0331 4.7693 24.0496 5.13744 23.8946 5.44743L22.0002 9.23629V20.0002C22.0002 20.5525 21.5525 21.0002 21.0002 21.0002H10.0002H3.00022C2.44793 21.0002 2.00022 20.5525 2.00022 20.0002V9.23629L0.105792 5.44743C-0.141197 4.95345 0.059027 4.35278 0.553005 4.10579ZM4.00022 10.0002V19.0002H9.00022V10.0002H4.00022ZM11.0002 10.0002V19.0002H20.0002V10.0002H11.0002ZM20.3822 8.00022L21.3822 6.00022H12.6183L11.6183 8.00022H20.3822Z'
      fill='currentColor'
    />
  </React.Fragment>
)
